import {translations} from 'locales/translations';
import {__} from 'utils/messages';

export default {
  paid: () => __(translations.invoiceCellsFeatures.paid, 'Paid'),
  used: () => __(translations.invoiceCellsFeatures.used, 'Used'),
  overpaid: () => __(translations.invoiceCellsFeatures.overpaid, 'Overpaid'),
};
